import { PageTarget } from "PFTypes/saved_filters";

export enum ApiFilterGroupV2 {
  Fields = "fields",
  Booleans = "booleans",
  Strings = "strings",
  Availability = "availability"
}

export enum KnownFiltersV2 {
  Availability = ApiFilterGroupV2.Availability,
  Id = "id",
  Term = "term",
  WorkforceMemberId = "workforceMemberId",
  BookingCategoryId = "bookingCategoryId",
  BookingCategoryIds = "bookingCategoryIds",
  ContributorId = "contributorId",
  OwnerId = "ownerId",
  WorkflowState = "workflowState",
  AuditAllocationWindowId = "auditAllocationWindowId",
  State = "state",
  Sold = "sold",
  Skills = "skills",
  Chargeable = "chargeable",
  ApproverId = "approverId",
  ActivityId = "activityId",
  AssigneeId = "assigneeId",
  CreatorId = "creatorId",
  Invited = "_invited",
  TemplateKey = "templateKey",
  TaskContributorId = "taskContributorId",
  ProfileId = "profileId",
  Grade = "grade",
  StartDate = "startDate",
  InterestedAt = "interestedAt",
  ReadStatus = "readStatus",
  DateRange = "dateRange",
  ParentActivityId = "parentActivityId",
  RequesterId = "requesterId",
  Period = "period"
}

type KnownFilterV2 = (typeof KnownFiltersV2)[keyof typeof KnownFiltersV2];

export type FilterKeyV2 = KnownFilterV2 | Lowercase<string>;

export type FilterPathV2 =
  | ApiFilterGroupV2.Availability
  | `children.${ApiFilterGroupV2.Availability}`
  | `${Exclude<ApiFilterGroupV2, ApiFilterGroupV2.Availability>}.${FilterKeyV2}`
  | `children.${Exclude<ApiFilterGroupV2, ApiFilterGroupV2.Availability>}.${FilterKeyV2}`;

export type FilteredCollectionKey = (typeof PageTarget)[keyof typeof PageTarget];
